/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="location.module.ts" />

module Meevo.Plugins.Location {
    import LocationStatusEnum = Meevo.Model.LocationStatusEnum;
    import SubscriptionStatusEnum = Meevo.Model.SubscriptionStatusEnum;
    import ILocationListItemBase = Meevo.Model.ILocationListItemBase;

    class LocationController extends Meevo.Components.BaseClasses.DataMaintenanceControllerBase {
        public displayNameColumnsCustom = {
            header: 'Name', fieldName: 'storeName', sortDirection: Model.SortDirection.Ascending, width: 20
        };
        public coColumnsCustom = [
            { header: 'Store #', fieldName: 'storeNumber', sortDirection: null, width: 10 },
            { header: 'State', fieldName: 'state', sortDirection: null, width: 10 },
            { header: 'Business Type', fieldName: 'businessType', sortDirection: null, width: 15 },
            { header: 'Status', fieldName: 'status', sortDirection: null, width: 25 },
            { header: 'Subscription Status', fieldName: 'subscrptionStatus', sortDirection: null, width: 15 },
            { header: 'System Start / Install Date', fieldName: 'SystemStartInstallDate', sortDirection: null, width: 15 },
            { header: '', fieldName: 'icon', sortDirection: null, width: 10 }
        ];

        public statusMap = {
            [LocationStatusEnum.Active]: 'LABEL_ACTIVE',
            [LocationStatusEnum.Closed]: 'LABEL_CLOSED',
            [LocationStatusEnum.TemporarilyClosed]: 'LABEL_TEMPORARILY_CLOSED',
            [LocationStatusEnum.ClosingPlanned]: 'LABEL_CLOSING_PLANNED'
        };

        public subscriptionStatusMap = {
            [SubscriptionStatusEnum.Active]: 'LABEL_ACTIVE',
            [SubscriptionStatusEnum.Cancelled]: 'LABEL_CANCELLED',
            [SubscriptionStatusEnum.Frozen]: 'LABEL_FROZEN',
            [SubscriptionStatusEnum.Inactive]: 'LABEL_INACTIVE',
            [SubscriptionStatusEnum.Pending]: 'LABEL_PENDING',
            [SubscriptionStatusEnum.Suspended]: 'LABEL_SUSPENDED',
            [SubscriptionStatusEnum.Terminated]: 'LABEL_TERMINATED',
            [SubscriptionStatusEnum.Upgrading]: 'LABEL_UPGRADING'
        };
        public userHasAnyBusinesstypeAccess:boolean;

        static $inject = [
            "meevo.AppSettings",
            "meevo.components.common.DataService",
            "meevo.components.modal.ModalService",
            "meevo.components.common.IdentityService",
            "meevo.components.logging.LoggingService",
            "meevo.components.common.SecurityService",
            "meevo.components.tracking.TrackingService",
            "$rootScope",
            "$scope",
            "$state",
            "meevo.ContextParams",
            'meevo.components.short-cuts.ShortCutsService',
            "meevo.components.busy.BusyService",
            "$translate",
            "$q"];

        constructor(protected appSettings: Meevo.Components.Common.IAppSettings,
            protected dataService: Meevo.Components.BaseClasses.IDataService,
            protected modalService: Meevo.Components.Modal.IModalService,
            protected identityService: Meevo.Components.Common.IIdentityService,
            protected loggingService: Meevo.Components.Logging.ILoggingService,
            protected securityService: Meevo.Components.Common.ISecurityService,
            protected trackingService: Meevo.Components.Tracking.ITrackingService,
            protected $rootScope: angular.IRootScopeService,
            protected $scope: angular.IScope,
            protected $state: any,
            protected contextParams: Meevo.IContextParams,
            protected shortCutsService: Meevo.Components.ShortCuts.IShortCutsService,
            protected busyService: Meevo.Components.Busy.IBusyService,
            protected $translate: angular.translate.ITranslateService,
            protected $q: angular.IQService) {

            
            super(appSettings, dataService, modalService, identityService, loggingService, $scope, contextParams, $state, $rootScope, shortCutsService);

            if (this.identityService.userBusinessTypes.length == 1) {
                this.coColumnsCustom = [
                    { header: 'Store #', fieldName: 'storeNumber', sortDirection: null, width: 15 },
                    { header: 'State', fieldName: 'state', sortDirection: null, width: 15 },
                    { header: 'Status', fieldName: 'status', sortDirection: null, width: 25 },
                    { header: 'Subscription Status', fieldName: 'subscrptionStatus', sortDirection: null, width: 15 },
                    { header: 'System Start / Install Date', fieldName: 'SystemStartInstallDate', sortDirection: null, width: 15 },
                    { header: '', fieldName: 'icon', sortDirection: null, width: 10 }
                ];
            }
            if (this.identityService.userBusinessTypes.length == 0) {
                this.coColumnsCustom = [];
                this.displayNameColumnsCustom = {
                    header: null, fieldName:null, sortDirection: Model.SortDirection.Ascending, width: 0
                };
            }
            if (this.identityService.userBusinessTypes.length > 0) {
                this.userHasAnyBusinesstypeAccess = true;
            } 
        }

       /**
       * Creates the context for editing/adding an item.
       * @return {}
       */
        createContext(): void {
            this.busyService.start();
            this.securityService.checkSection(this.meevoSecurityKeys.MANAGEMENT_LOCATION).then(() => {
                this.busyService.stop();
                this.context = new LocationContext(this.appSettings, this.dataService, this.modalService, this.identityService, this.loggingService, this.securityService, this.trackingService, this.busyService, this.$q);
                this.context.activate(this.selectedItemId, null, this.asLocationId);
                this.context.deactivate = () => {
                    this.selectedItemId = null;
                    this.visualState = Model.MaintenanceFormVisualState.Search;
                };
            }).finally(() => {
                this.busyService.stop();
            });
        }

        /**
         * Before search callbalck
         * @param criteria
         * @param rootCriteria
         */
        preSearchCallback(criteria, rootCriteria) {
            criteria.locationStatusEnums = [];

            if (criteria.active) criteria.locationStatusEnums.push(LocationStatusEnum.Active);

            if (criteria.closed) criteria.locationStatusEnums.push(LocationStatusEnum.Closed);

            if (criteria.temporarilyClosed) criteria.locationStatusEnums.push(LocationStatusEnum.TemporarilyClosed);

            if (criteria.closingPlanned) criteria.locationStatusEnums.push(LocationStatusEnum.ClosingPlanned);

            criteria.businessType_TId = (criteria.businessType && criteria.businessType.id) ? criteria.businessType.id : null;

            criteria.state = (criteria.locationState && criteria.locationState.state) ? criteria.locationState.state : null;

            rootCriteria.sortBy = 'storeName';
        }

        /**
         * Format search result data
         * @param pageNumber
         * @param {Array<ILocationListItemBase>} locationList
         */
        formatSearchResultData = (pageNumber, locationList: Array<ILocationListItemBase>) => {
            locationList.forEach(location => {
                location.locationStatusDisplayName = this.statusMap[location.locationStatusEnum];
                location.subscriptionStatusName = this.subscriptionStatusMap[location.subscriptionStatus];

            });
        }
    }

    angular.module("meevo.plugins.location")
        .controller("meevo.plugins.location.LocationController", LocationController);
}